export const ROUTE_HOME = '/'
export const ROUTE_OVERVIEW = '/'
export const ROUTE_PREFERENCES = '/settings'
export const ROUTE_SUBSCRIPTION = '/subscription'
export const ROUTE_ONBOARDING = '/onboarding'
export const ROUTE_MARKETS = '/markets'
export const STRICT_ONBOARDING_ROUTES = ['/onboarding']
